export function FN_SERIALIZATION__is_primitive_type(value: unknown): boolean {
  const type = typeof value;
  return value === null || type === 'string' || type === 'number' || type === 'boolean' || type === 'undefined' || type === 'symbol' || type === 'bigint';
}
